module.exports = __webpack_public_path__ + "img/Ute_Front_Side_Left_Transparent.57d0480e.svg";